module.exports = __webpack_public_path__ + "img/15.447f955d.svg";